import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MD_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MD_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 0h10v24H22V0z",
      fill: "#D9071E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h12v24H0V0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 0h12v24H10V0z",
      fill: "#FBCD17"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.719 19.613l-1.053.576-3.491-6.389 1.053-.575 3.49 6.388zm-11.205.154l1.053.575 3.49-6.389-1.053-.575-3.49 6.389z",
      fill: "#FD1900"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.378 9.389v5.551c0 1.234-1.062 2.84-1.597 3.439-.536.598-1.6 1.967-1.6 1.967V5.408c0-1.675 1.6-2.25 1.6-2.25s1.328.262 1.597 2.25v1.938c.411.324 1.784 1.316 2.67.897 1.053-.497 1.416-1.924 1.416-1.924s-.098-1.44-.53-1.44c-.432 0-.467-2.028 1.188-2.028 1.654 0 1.847.781 1.847 1.405 0 .326-.262.85-.51 1.35-.227.452-.443.884-.443 1.129 0 .513.387 1.508.953 1.508.397 0 2.307-.742 3.413-1.185v-1.65c.27-1.988 1.597-2.25 1.597-2.25s1.6.575 1.6 2.25v14.938s-1.064-1.37-1.6-1.967c-.536-.598-1.597-2.205-1.597-3.439V9.39H11.378zm1.772 10.443c1.082-.704 2.664-3.862 2.664-3.862l.525.122s.802 2.091 3.16 3.74c-2.513.67-3.16 2.018-3.16 2.018 0-1.078-3.189-2.018-3.189-2.018zm-.174-1.999c.73 0 1.32-.56 1.32-1.25s-.59-1.25-1.32-1.25c-.729 0-1.32.56-1.32 1.25s.591 1.25 1.32 1.25zm7.744-1.25c0 .69-.59 1.25-1.32 1.25-.729 0-1.32-.56-1.32-1.25s.591-1.25 1.32-1.25c.73 0 1.32.56 1.32 1.25z",
      fill: "#A77B3B"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.14 10.407l.918.397-3.74 8.652-.918-.397 3.74-8.652z",
      fill: "#FDFF00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.04 7.833H21.6v7.639s-2.688.81-5.28 2.137c-1.915-1.42-5.28-2.137-5.28-2.137V7.833z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MD_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 11,
      y: 7,
      width: 11,
      height: 11
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.04 7.833H21.6v7.639s-2.688.81-5.28 2.137c-1.915-1.42-5.28-2.137-5.28-2.137V7.833z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MD_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#3D58DB", d: "M11.039 12.833h10.56v5h-10.56z" }), /* @__PURE__ */ e.createElement("path", { fill: "#FD1900", d: "M11.039 7.833h10.56v5h-10.56z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.786 10.082l-.8.066.46-.622-.491-.645.804.103.309-.71.342.726.8-.067-.46.623.491.645-.804-.104-.309.711-.342-.726z",
      fill: "#FDFF00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.349 8.671s-2.15 1.308-1.434 2.247c.717.939 1.62 1.06 1.62 1.06s-2.2 3.298 1.67 5.183c4.145-1.82 1.965-5.184 1.965-5.184s1.276-.282 1.531-1.297c.256-1.016-1.667-2.18-1.667-2.18s1.2 1.739.926 2.18c-.274.44-1.741.89-2.754.89s-2.578-.285-2.83-1.056c-.253-.77.973-1.843.973-1.843z",
      fill: "#FDFF00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.36 12l1.32.833-1.32.834-1.32-.834L12.36 12zM20.279 12l1.32.833-1.32.834-1.32-.834 1.32-.833zM12.32 15.3a.4.4 0 100-.8.4.4 0 000 .8zM20.829 14.543c-.343-.278-.87-.197-1.176.18-.305.378-.275.91.068 1.188.187.15.09-.45.372-.832.237-.32.893-.41.736-.536z",
      fill: "#FDFF00"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.736 11.529s1.054 1.246 2.047.838c.993-.407.752-1.868.752-1.868l-.752.682h-.64v.348l-.5-.348v.348h-.907zm.713 1.915s1.285 1.12 2.15.803c.866-.316.649-1.833.649-1.833l-.752.682h-.64v.348l-.5-.348v.348h-.907zm3.46 2.543c-.866.316-2.151-.804-2.151-.804h.907v-.348l.5.348v-.348h.64l.751-.682s.218 1.517-.648 1.834z",
      fill: "#048F02"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.979 2.248h-1v.596h-.471v1h.47v1.744h1V3.844h.573v-1h-.572v-.596z",
      fill: "#FDFF00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.158 3.384l-2.316.596 2.316.732V3.384z",
      fill: "#DB4400"
    }
  ))
), d = t;
export {
  d as default
};
